import { BaseEntity } from "yt-ng-framework";

export class UlazniDokumentDobavljaca extends BaseEntity{
    constructor(){
        super();
    }

    OrgJedID: number = null;
    PodVrstaDokumentaStavkaID: number = null;
    Broj: string = null;
    BrojUlaznogDokumentaDobavljaca: string = null;
    Datum: Date = null;
    KomitentID: number = null;
    ObjekatID: number = null;
    DatumPlacanja: Date = null;
    BrojUgovora: string = null;
    PozivNaBroj: string = null;
    Napomena: string = " ";
    DokumentPdf: string = " ";
    Iznos: number = null;
    MasterDokumID: number = null;
    DokumentPdfByte: Blob = null;
    ProvajderID: number = null;
    StatusTooltip:string;

    Deserialize(input: any){
        this.ID = input.ID;
        this.OrgJedID = input.OrgJedID;
        this.PodVrstaDokumentaStavkaID = input.PodVrstaDokumentaStavkaID;
        this.Broj = input.Broj;
        this.BrojUlaznogDokumentaDobavljaca = input.BrojUlaznogDokumentaDobavljaca;
        this.Datum = input.Datum;
        this.KomitentID = input.KomitentID;
        this.ObjekatID = input.ObjekatID;
        this.DatumPlacanja = input.DatumPlacanja;
        this.BrojUgovora = input.BrojUgovora;
        this.PozivNaBroj = input.PozivNaBroj;
        this.Napomena = input.Napomena;
        this.DokumentPdf = input.DokumentPdf;
        this.Iznos = input.Iznos;
        this.MasterDokumID =  input.MasterDokumID;
        this.DokumentPdfByte = input.DokumentPdfByte;
        this.ProvajderID=input.ProvajderID;
        this.StatusTooltip = input.StatusTooltip;
        return this;
    }

    Serialize(input: UlazniDokumentDobavljaca){
        return input;
    }

    GetInstance(){
        return this;
    }
}